import { create } from "zustand";
import ApiService from "Helpers/ApiService";

interface AuthStoreState {
    login: (usernameOrEmail: string, password: string) => Promise<{ accessToken?: string }>;
    register: (email: string, username: string, password: string) => Promise<{ accessToken?: string }>;
    googleSignIn: (accessToken: string) => Promise<{ Token?: string }>;
}

export const useAuthStore = create<AuthStoreState>(() => ({
    login: (usernameOrEmail, password) => ApiService.login(usernameOrEmail, password),
    register: (email, username, password) => ApiService.register(email, username, password),
    googleSignIn: (accessToken) => ApiService.googleSignIn(accessToken),
}));
